import React from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";
import { Sentry, SentryAdapter, Environment } from "./index";
import { LogContext } from "./logger.context";


interface ISentryConfig {
    dsn: string;
    environment: Environment;
    replaysSessionSampleRate: number;
    replaysOnErrorSampleRate: number;
    context: LogContext;
}

export class SentryLogger extends SentryAdapter {
    constructor(options: ISentryConfig) {
        super();
        if (options.dsn) {
            Sentry.setUser({
                fullName: options.context?.user?.username,
                email: options.context?.user?.email ?? undefined,
            });
            Sentry.init({
                ...options,
                sendDefaultPii: true,
                enableLogs: true,
                integrations: [
                    Sentry.feedbackSyncIntegration({
                        autoInject: false,
                        showName: false,
                        showEmail: false,
                    }),
                    Sentry.replayIntegration({
                        maskAllText: false,
                        blockAllMedia: false,
                        maskAllInputs: false,
                    }),
                    Sentry.reactRouterV7BrowserTracingIntegration({
                        useEffect: React.useEffect,
                        useLocation,
                        useNavigationType,
                        createRoutesFromChildren,
                        matchRoutes,
                    }),
                ],
            });
        }
    }

}